import { formatNumber } from '@fv/client-core'

import { useLocale } from './useLocale'

export function usePrettyNumber() {
  const locale = useLocale()
  return (n?: number | string | null) => formatNumber(n, locale)
}
